import { Icon } from './ui/Icon.js';

interface PaginationProps {
  total: number;
  limit: number;
  offset: number;
  onPageChange: (newOffset: number) => void;
}

export function Pagination({ total, limit, offset, onPageChange }: PaginationProps) {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const hasPrev = offset > 0;
  const hasNext = offset + limit < total;

  if (total === 0) return null;

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex flex-1 items-center justify-between">
        <p className="text-sm text-gray-700">
          Showing{' '}
          <span className="font-medium">{offset + 1}</span>
          {' '}-{' '}
          <span className="font-medium">{Math.min(offset + limit, total)}</span>
          {' '}of{' '}
          <span className="font-medium">{total}</span>
          {' '}results
        </p>
        {/* Spec 250 (review P2): Kridt's round quiet buttons either side of a
            plain "Page n of m". It was three 8px boxes joined by a Tailwind
            ring — which is a box-shadow, the one thing Kridt has none of. */}
        <nav className="inline-flex items-center gap-2" aria-label="Pagination">
          <button
            type="button"
            onClick={() => onPageChange(Math.max(0, offset - limit))}
            disabled={!hasPrev}
            className="hub-btn hub-btn--quiet hub-btn--icon"
            aria-label="Previous page"
          >
            <Icon name="bx-chevron-left" />
          </button>
          <span className="text-sm text-[var(--hub-color-ink-muted)]">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange(offset + limit)}
            disabled={!hasNext}
            className="hub-btn hub-btn--quiet hub-btn--icon"
            aria-label="Next page"
          >
            <Icon name="bx-chevron-right" />
          </button>
        </nav>
      </div>
    </div>
  );
}
